"use strict";
export function selectTransactionSettings(key) {
  return (state) => state.transactionSettings[key];
}
